import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

// Example image and logo imports—adjust paths/filenames as needed.
import LogoSVG from '../assets/BantrBoxLogo.svg';
import FeaturedImage2 from '../assets/blog-feature2.jpg';

const BlogPost2 = () => {
  return (
    <div className="bg-white text-gray-800 min-h-screen flex flex-col">
      {/* Header Bar */}
      <header className="bg-[#333333] shadow-sm text-white">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src={LogoSVG} 
              alt="BantrBox Logo" 
              className="h-12 w-auto"
            />
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 py-10 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-4 leading-tight">
            Compete Smarter, Not Harder: Building a Culture of Responsible Bantr
          </h1>
          <p className="text-sm text-gray-500 mb-6">
            Published: October 3, 2024 • By BantrBox Team
          </p>

          {/* Featured Image */}
          <div className="w-full mb-8">
            <img
              src={FeaturedImage2}
              alt="Responsible Bantr"
              className="w-full h-auto rounded-lg shadow-lg object-cover"
            />
          </div>

          <div className="space-y-6 leading-relaxed text-lg">
            <p>
              A friendly challenge with friends can transform an ordinary day into a thrilling story. 
              But how do you ensure that “fun” never crosses over into stress or frustration? At BantrBox, 
              we believe in competitions that lift everyone up—and keep negativity at bay. Here are our 
              top tips for building a culture of responsible Bantr so you can keep things light, fair, 
              and downright entertaining.
            </p>

            <h2 className="text-2xl font-semibold">1. Match the Challenge to the Goal</h2>
            <p>
              Fancy yourself a risk-taker, or maybe you’re new to the competitive scene? Set your 
              friendly showdowns according to the length or difficulty of the challenge. If it’s a 
              quick 24-hour goal, keep it short and sweet. For something that spans weeks, agree 
              on the kind of bragging rights or fun payoff that suits everyone. The key is 
              understanding each other’s comfort levels from the start.
            </p>

            <h2 className="text-2xl font-semibold">2. Prioritize Growth Over Gains</h2>
            <p>
              Whether you’re challenging a friend to run a 5K, cook a new cuisine, or learn a 
              new language, it should be about your collective accomplishments, not just one 
              person’s “win.” Emphasizing personal development helps maintain a positive atmosphere. 
              You’ll find that the best part of these showdowns is the journey, not just the 
              outcome.
            </p>

            <h2 className="text-2xl font-semibold">3. Keep It Transparent & Light</h2>
            <p>
              Nothing ruins a friendly rivalry faster than hidden rules or misunderstood expectations. 
              Lay out the challenge clearly—whether it’s a creative prompt, a fitness quest, or a 
              test of knowledge. Make sure everyone understands the timeline, success criteria, and 
              any special conditions (like no outside help!). A transparent process keeps the 
              competition fair and the vibes positive.
            </p>

            <h2 className="text-2xl font-semibold">4. Embrace Community Support</h2>
            <p>
              Part of BantrBox’s charm is our vibrant community, which cheers on triumphs and 
              embraces setbacks with encouragement. If a friend misses a milestone, show some 
              understanding and offer to help them get back on track. A little community support 
              goes a long way in making sure everyone feels uplifted.
            </p>

            <h2 className="text-2xl font-semibold">5. Celebrate Every Victory—Big or Small</h2>
            <p>
              Even if you don’t come out on top, there’s always something worth celebrating. 
              Maybe you didn’t beat your friend’s personal best, but you learned a new skill or 
              got in better shape along the way. Make a habit of shouting out each other’s 
              milestones. It fosters a sense of camaraderie and keeps the spirit of Bantr alive 
              and well.
            </p>

            <p>
              Ready to keep it fun, fair, and fulfilling? Challenge your friends to that next 
              big (or small) adventure, and discover how responsible competition can spark lasting 
              memories. When done right, everyone wins—regardless of who crosses the finish line 
              first.
            </p>

            <p className="italic">
              Think of BantrBox as your sandbox for friendly challenges. Keep it playful, keep 
              it respectful, and never stop celebrating each other’s wins.
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default BlogPost2;
